import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TreeNodeDragDrop from './treeNodeDragDrop';

/**
 *  Based on https://github.com/elifTech/treeview-react-bootstrap
 *
 *  This class includes as an integral  subcomponent TreeNodeDragDrop (./treeNode.js).
 */
class TreeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: null,
      target: null,
      draggingId: null
    };

    // method binding
    this.handleMove = this.handleMove.bind(this);
    this.selectNode = this.selectNode.bind(this);
    this.targetNode = this.targetNode.bind(this);
  }
  handleMove(fromNode, toNode, index) {
    const onMove = this.props.onMove;
    onMove(fromNode, toNode, index);
  }
  selectNode(node) {
    const selectedId = this.state.selectedId;
    let newID = null;
    if (node && node.id) {
      newID = node.id;
    }
    if (selectedId !== newID) {
      this.setState({
        selectedId: newID
      });
    }
  }
  targetNode(fromNode, toNode) {
    const target = this.state.target;
    // let target = null; // this target was not being used... Should it be?
    const node = toNode;
    let draggingId = null;
    if (node && node.id && fromNode.id !== toNode.id) {
      // target = node; // this target was not being used... Should it be?
      draggingId = fromNode.id;
    }
    if (!_.isEqual(target, node)) {
      this.setState({
        draggingId,
        target: node
      });
    }
  }
  hasTarget(nodes) {
    const target = this.state.target;
    return !_.isNull(target) && (target.id === 'dummy' && _.isNull(target.parentID) || nodes.some(currentNode => currentNode.id === target.id));
  }
  render() {
    const _this$props = this.props,
      nodes = _this$props.nodes,
      enableLinks = _this$props.enableLinks,
      onAdd = _this$props.onAdd,
      onRemove = _this$props.onRemove,
      onSave = _this$props.onSave;
    const _this$state = this.state,
      selectedId = _this$state.selectedId,
      target = _this$state.target,
      draggingId = _this$state.draggingId;
    const children = [];
    if (nodes) {
      const sorted = _.sortBy(nodes, 'sortOrder');
      if (this.hasTarget(sorted)) {
        sorted.push({
          id: 'dummy',
          name: ' ',
          parentID: null
        });
      }
      sorted.forEach((currentNode, index) => {
        children.push(/*#__PURE__*/React.createElement(TreeNodeDragDrop, {
          ref: "treeNode-".concat(currentNode.id),
          index: index,
          node: currentNode,
          key: currentNode.id,
          isLast: index === nodes.length - 1,
          level: 1,
          enableLinks: enableLinks,
          selectedId: selectedId,
          target: target,
          draggingId: draggingId,
          selectNode: this.selectNode,
          onMove: this.handleMove,
          onAdd: onAdd,
          onRemove: onRemove,
          onSave: onSave,
          onTargetHover: this.targetNode
        }));
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      id: "treeview",
      className: "treeview t-tv-tree-view"
    }, children, /*#__PURE__*/React.createElement("div", {
      className: "list-item t-tv-lit-item"
    }));
  }
}
TreeView.defaultProps = {
  enableLinks: false
};
TreeView.propTypes = {
  nodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  enableLinks: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

// export default DragDropContext(HTML5Backend)(TreeView);
export default props => /*#__PURE__*/React.createElement(TreeView, props);